/**
 * Shared quiz acknowledgment toast.
 *
 * Why this matters: DMM and USCN should have identical feedback placement and
 * timing. Keeping the presentation shared prevents one brand from drifting
 * away from the other while each quiz still controls its own copy.
 */
import React from 'react';
import { QUIZ_ACK_DURATION_MS } from '../utils/quizConfetti';
import './QuizAcknowledgment.css';

interface QuizAcknowledgmentProps {
  line: string;
  kicker: string;
}

const QuizLeafCheck: React.FC = () => (
  <svg
    className="quiz-ack-leaf-check"
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path
      className="quiz-ack-leaf-check-path"
      d="M6 18.5C6 10.5 11 5.5 19 5c.5 8-4.5 13-12.5 13.5z"
      pathLength="100"
    />
    <path
      className="quiz-ack-leaf-check-path quiz-ack-leaf-check-rib"
      d="M6 18.5c2.2-4.6 5.4-8 9.6-10.2"
      pathLength="100"
    />
  </svg>
);

const QuizAcknowledgment: React.FC<QuizAcknowledgmentProps> = ({ line, kicker }) => (
  <div className="quiz-ack-slot" role="status" aria-live="polite">
    <div
      className="quiz-ack-card"
      style={{ '--quiz-ack-duration': `${QUIZ_ACK_DURATION_MS}ms` } as React.CSSProperties}
    >
      <span className="quiz-ack-icon">
        <QuizLeafCheck />
      </span>
      <span className="quiz-ack-copy">
        <span className="quiz-ack-kicker">{kicker}</span>
        <span className="quiz-ack-line">{line}</span>
      </span>
      <span className="quiz-ack-progress" aria-hidden="true" />
    </div>
  </div>
);

export default QuizAcknowledgment;
